import { render, staticRenderFns } from "./Portal_all.vue?vue&type=template&id=81017962&"
import script from "./Portal_all.vue?vue&type=script&lang=js&"
export * from "./Portal_all.vue?vue&type=script&lang=js&"
import style0 from "./Portal_all.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/vuetify_1/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBottomNav } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VNavigationDrawer } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarSideIcon } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VApp,VBottomNav,VBtn,VCard,VCardText,VCardTitle,VCombobox,VContainer,VContent,VForm,VIcon,VNavigationDrawer,VSelect,VSpacer,VToolbar,VToolbarSideIcon,VToolbarTitle,VTreeview})
